import { useWindowDimensions } from "@-/com.npmjs.react-native";
import { useAnimatedStyle, useSharedValue } from "@-/com.npmjs.react-native-reanimated";
import { useToolbarGridMetrics } from "@-/dev.improve.haniverse.components.ui.toolbar.button.view";
import { type LearnMapCardFrame, learnMapCoveredFade } from "#learn-map-cards-motion";
import { useLearnMapModeSelector } from "#use-learn-map-mode";

/**
 * The opacity of chrome Learn's card slides over on its way to the map: Learn's toolbar row
 * (`"toolbar"`, which follows `toolbarProgress` and so snaps back for a page opened over the map)
 * and the cards' backdrop (`"cards"`). It stays put and fades only while the card covers Learn's
 * toolbar (`learnMapCoveredFade`), uncovering the map and its own toolbar beneath.
 */
export function useLearnMapCoveredOpacityStyle(source: "cards" | "toolbar") {
  const cardsProgress = useSharedValue(0);
  const unmeasuredCardFrame = useSharedValue<LearnMapCardFrame | null>(null);
  const progress =
    useLearnMapModeSelector((mode) =>
      source === "toolbar" ? mode.toolbarProgress : mode.progress,
    ) ?? cardsProgress;
  const cardFrame = useLearnMapModeSelector((mode) => mode.cardFrame) ?? unmeasuredCardFrame;
  const { height: rowHeight, isLandscape } = useToolbarGridMetrics();
  const { height: windowHeight } = useWindowDimensions();
  // Landscape's toolbar is a column beside the card rather than a row above it.
  const toolbarRowHeight = isLandscape ? 0 : rowHeight;
  return useAnimatedStyle(() => ({
    opacity:
      1 - learnMapCoveredFade(progress.get(), cardFrame.get(), toolbarRowHeight, windowHeight),
  }));
}
